import { get } from 'api';
import { cleanObject } from 'utils/object';

import { LOAD_PRODUCTS, PRODUCTS_LOADED, RESET_PRODUCTS, SYNC_FAILED } from './actionTypes';
import type { IEnvCropsProductsActions, IGetProductsParams } from './types';

export const initialActionsState: IEnvCropsProductsActions = {
  loadProducts: () => {},
  resetProducts: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  loadProducts: async (params: IGetProductsParams = {}) => {
    dispatch({
      type: LOAD_PRODUCTS,
    });
    const { data, error } = await get('/kings/products', {
      params: cleanObject(params),
    });
    if (data && !error) {
      dispatch({
        type: PRODUCTS_LOADED,
        payload: { data, params },
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },

  resetProducts: () =>
    dispatch({
      type: RESET_PRODUCTS,
    }),
});
